import type { InterfaceEntity } from '@unifyapps/defs/types/interface';
import type { User } from '@unifyapps/network/generated/models/user';
import { DUMMY_INTERFACE_RECORD } from '../../../const/dummy';
import type { DeviceContextInStore } from '../../../stores/app/GlobalAppStateStore/types';
import { getUserContextWithLegacyDeviceContext } from '../../../utils/deviceContextAdapters';
import { ComputeContextKeys } from '../const';
import { getInterfaceRecordForComputeContext } from './getInterfaceRecordForComputeContext';
import getInterfaceRecordForState from './getInterfaceRecordForState';

export interface BaseComputeContextParams {
  interfaceRecord: InterfaceEntity | undefined;
  userContext: User | undefined;
  deviceContext?: DeviceContextInStore;
  envVariables: Record<string, string>;
  localStorage?: Record<string, unknown>;
  activeAppVariantKey?: string;
}

export function buildAppLevelComputeContext({
  interfaceRecord,
  userContext,
  deviceContext,
  envVariables,
  localStorage,
  activeAppVariantKey,
}: BaseComputeContextParams) {
  const interfaceRecordForContext = getInterfaceRecordForComputeContext({
    interfaceRecord: interfaceRecord ?? DUMMY_INTERFACE_RECORD,
  });
  return {
    interfaceRecord: getInterfaceRecordForState(interfaceRecordForContext, activeAppVariantKey),
    // legacy `userContext.context.*` bindings resolve via the derived view, same as the
    // page-level ContextBuilder — e.g. default-page rules evaluated by useResolvePageId.
    userContext: getUserContextWithLegacyDeviceContext(userContext, deviceContext),
    [ComputeContextKeys.DEVICE]: deviceContext,
    envVariables,
    localStorage: localStorage ? { values: localStorage } : { values: {} },
  };
}
